module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gallery-image",
    class: _vm.bemFacet
  }, [_c('button', {
    staticClass: "u-reset gallery-image--btn",
    attrs: {
      "type": "button",
      "disabled": _vm.hasClickListener ? null : true
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onImageClicked($event)
      }
    }
  }, [_c('span', {
    staticClass: "gallery-image--wrap"
  }, [_c('img', {
    staticClass: "gallery-image--image-accessor",
    attrs: {
      "src": _vm.preloadGuardedSrc,
      "alt": _vm.resource.alt
    }
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6bb4352e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bb4352e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/cms-plugins/gallery-image/index.vue
// module id = 556
// module chunks = 7